import Button from '@/components/atoms/button/button';
import ToBeAwareImage from '@/components/atoms/to-be-aware-image/toBeAwareImage';
import { useContext, useEffect } from 'react';
import GlobalContext from '../../../contexts/globalContext';
import { TabsEnum } from '../../../enums/enums';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import Breadcrumb from '../../atoms/breadcrumb/breadcrumb';
import Loader from '../../atoms/loader/loader';
import ToBeAware from '../../atoms/to-be-aware/to-be-aware';
import './formAndNoteTemplate.scss';

const FormAndNoteTemplate = ({
    children,
    desiredTab,
    subRoute,
    buttonCopy,
    buttonEvent,
    breadCrum,
    title,
    subtitle,
    secondTitle,
    secondSubtitle,
    note,
    disableButton,
    loader,
    notePosition,
    isSecondButton,
    buttonCopyTwo,
    buttonEventTwo,
    disableButtonTwo,
    loaderSecondButton,
    historicButton,
    historicButtonClass,
    historicButtonOnClickAction,
    historicButtonDisable,
    historicButtonText,
    showFirstButton = true,
}: any) => {
    const { window, localStorage } = useBrowserMode();
    const { selectedTab } = useContext(GlobalContext);

    useEffect(() => {
        const tab = localStorage.getItem('CURRENT_TAB');
        if (!desiredTab) return;
        if (desiredTab === 'none') return;
        if (!tab || tab === 'undefined') return;
        if (desiredTab !== 'personas') {
            location.href =
                window && window?.location.hostname === 'localhost'
                    ? validateSubRoute('/personas/')
                    : validateSubRoute('/portal-servicios/personas/');
            return;
        }
        if (tab === TabsEnum.BUSINESS) {
            location.href =
                window && window?.location.hostname === 'localhost'
                    ? validateSubRoute('/empresas/')
                    : validateSubRoute('/portal-servicios/empresas/');
        }
    }, [selectedTab?.get]);

    const validateSubRoute = (route: string) => {
        if (subRoute) {
            return route + subRoute;
        }
        return route;
    };

    return (
        <div className="o-form-and-note-template">
            {breadCrum && <Breadcrumb content={breadCrum} />}
            {title || subtitle ? (
                <div className="o-form-and-note-template__headings">
                    <div className="o-form-and-note-template__headings__titles">
                        {title && (
                            <h1 className="o-form-and-note-template__headings__titles__title">
                                {title}
                            </h1>
                        )}
                        {subtitle && (
                            <p className="o-form-and-note-template__headings__titles__subtitle">
                                {subtitle}
                            </p>
                        )}
                    </div>
                    <div className="o-form-and-note-template__headings__button">
                        {historicButton && (
                            <Button
                                text={historicButtonText || 'Historico'}
                                isDisabled={historicButtonDisable}
                                classname={historicButtonClass}
                                onClickAction={historicButtonOnClickAction}
                                type={'button'}
                            />
                        )}
                    </div>
                </div>
            ) : (
                <div className="o-form-and-note-template__spacer"></div>
            )}
            <div className="o-form-and-note-template__content">
                <div className={'o-form-and-note-template__content__body '}>
                    {notePosition === 'left' ? (
                        <ToBeAwareImage
                            image={note.image}
                            title={note.title}
                            content={note.content}
                        />
                    ) : (
                        <ToBeAware content={note} />
                    )}
                    <div
                        className={
                            'o-form-and-note-template__content__body__form ' +
                            (notePosition === 'left' ? '--invert' : '')
                        }
                    >
                        {(secondTitle || secondSubtitle) && (
                            <div className="o-form-and-note-template__content__body__form__info">
                                {secondTitle && (
                                    <h3 className="o-form-and-note-template__content__body__form__info__title">
                                        {secondTitle}
                                    </h3>
                                )}
                                {secondSubtitle && (
                                    <span className="o-form-and-note-template__content__body__form__info__subtitle">
                                        {secondSubtitle}
                                    </span>
                                )}
                            </div>
                        )}
                        {children && (
                            <div className="o-form-and-note-template__content__body__form__row">
                                {children}
                            </div>
                        )}
                        <div className="o-form-and-note-template__content__form__buttons">
                            {isSecondButton && (
                                <button
                                    className="o-form-and-note-template__content__form__secondButton"
                                    disabled={
                                        loaderSecondButton || disableButtonTwo
                                    }
                                    onClick={() => {
                                        buttonEventTwo && buttonEventTwo();
                                    }}
                                >
                                    {loaderSecondButton ? (
                                        <Loader size="__small" />
                                    ) : (
                                        buttonCopyTwo || 'Volver'
                                    )}
                                </button>
                            )}
                            {showFirstButton && (
                                <button
                                    className="o-form-and-note-template__content__form__button"
                                    disabled={loader || disableButton}
                                    onClick={() => {
                                        buttonEvent && buttonEvent();
                                    }}
                                >
                                    {loader ? (
                                        <Loader size="__small" />
                                    ) : (
                                        buttonCopy || 'Aceptar'
                                    )}
                                </button>
                            )}
                        </div>
                        {disableButton &&
                            location.pathname.startsWith('empresas') && (
                                <p className="o-form-and-note-template__error">
                                    * debes elegir una empresa en el menú
                                </p>
                            )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormAndNoteTemplate;
